window.addEventListener('scroll', () => {
  const footer = document.querySelector('.footer-reveal');
  if (!footer) return;

  const scrollPosition = window.scrollY + window.innerHeight;
  const pageHeight = document.documentElement.scrollHeight;

  // When scrolled within 100px of the bottom, reveal footer
  if (scrollPosition > pageHeight - 100) {
    footer.classList.add('visible');
  } else {
    footer.classList.remove('visible');
  }
});
